import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { Id } from '@/infra/id'

export type Section7216AcceptanceProps = ModelProps<Section7216Acceptance>

export class Section7216Acceptance extends Model<Section7216Acceptance> {
  id = Id.none
  @observable accessor section7216Id = Id.none
  @observable accessor userPublicId = Id.none
  @observable accessor userSignature = ''
  @observable accessor spouseSignature: string | null = null
  @observable accessor createdAt = unixEpoch()
}
